import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { toast } from 'sonner';
import api, { formatErrorDetail } from '@/lib/api';
import { IDS } from '@/constants/testIds';

export default function BookingForm({ tourSlug, tourTitle }) {
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    guests: 2,
    preferred_date: '',
    message: '',
  });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      toast.error('Пожалуйста, заполните имя и телефон');
      return;
    }
    setSubmitting(true);
    try {
      await api.post('/bookings', {
        tour_slug: tourSlug,
        tour_title: tourTitle,
        ...form,
      });
      toast.success('Заявка отправлена! Али свяжется с вами в течение часа.');
      setForm({ name: '', phone: '', email: '', guests: 2, preferred_date: '', message: '' });
    } catch (err) {
      toast.error(formatErrorDetail(err.response?.data?.detail) || 'Ошибка отправки');
    } finally {
      setSubmitting(false);
    }
  };

  const input = 'w-full bg-transparent border-0 border-b border-border/60 py-3 focus:border-saffron transition-colors text-foreground placeholder:text-foreground/40 text-base';

  return (
    <motion.form
      data-testid={IDS.bookingForm}
      onSubmit={submit}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
      className="space-y-5"
    >
      <div>
        <label className="text-[10px] uppercase tracking-widest2 text-foreground/50 mb-1 block">Как вас зовут *</label>
        <input
          data-testid={IDS.bookingName}
          className={input}
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          required
          placeholder="Имя и фамилия"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div>
          <label className="text-[10px] uppercase tracking-widest2 text-foreground/50 mb-1 block">Телефон / WhatsApp *</label>
          <input
            data-testid={IDS.bookingPhone}
            className={input}
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
            required
            placeholder="+7 999 123 45 67"
          />
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-widest2 text-foreground/50 mb-1 block">Email</label>
          <input
            data-testid={IDS.bookingEmail}
            className={input}
            type="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            placeholder="you@mail.ru"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div>
          <label className="text-[10px] uppercase tracking-widest2 text-foreground/50 mb-1 block">Гостей</label>
          <input
            data-testid={IDS.bookingGuests}
            className={input}
            type="number"
            min="1"
            max="20"
            value={form.guests}
            onChange={(e) => setForm({ ...form, guests: Math.max(1, +e.target.value || 1) })}
          />
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-widest2 text-foreground/50 mb-1 block">Желаемая дата</label>
          <input
            data-testid={IDS.bookingDate}
            className={input}
            type="date"
            value={form.preferred_date}
            onChange={(e) => setForm({ ...form, preferred_date: e.target.value })}
          />
        </div>
      </div>

      <div>
        <label className="text-[10px] uppercase tracking-widest2 text-foreground/50 mb-1 block">Комментарий</label>
        <textarea
          data-testid={IDS.bookingMessage}
          className={`${input} min-h-[100px] resize-none`}
          rows={3}
          value={form.message}
          onChange={(e) => setForm({ ...form, message: e.target.value })}
          placeholder="Пожелания, особенности, вопросы..."
        />
      </div>

      <motion.button
        data-testid={IDS.bookingSubmit}
        type="submit"
        disabled={submitting}
        whileTap={{ scale: 0.97 }}
        className="w-full py-4 border border-saffron text-saffron uppercase text-xs tracking-widest2 font-bold hover:bg-saffron hover:text-foreground transition-colors disabled:opacity-50"
      >
        {submitting ? 'Отправляем…' : 'Отправить заявку'}
      </motion.button>

      <p className="text-[10px] uppercase tracking-widest2 text-foreground/40 text-center">
        Заявка попадёт Али напрямую · Ответ в течение часа
      </p>
    </motion.form>
  );
}
